"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toStringArray = exports.generateSubsets = exports.zip = exports.asyncFind = exports.asyncSome = exports.convertArrayToMap = void 0;
/* Converts an array to Map, where keyName is dot separated value by default */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function convertArrayToMap(arrayObjects, keyName, separator = '.') {
    return new Map(arrayObjects.map((element) => {
        const getKeyValue = (el) => {
            const keys = keyName.split(separator);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return keys.reduce((previousValue, currentValue) => previousValue[currentValue], el);
        };
        const key = getKeyValue(element);
        return [key, element];
    }));
}
exports.convertArrayToMap = convertArrayToMap;
async function asyncSome(arr, predicate) {
    for await (const e of arr) {
        if (await predicate(e))
            return true;
    }
    return false;
}
exports.asyncSome = asyncSome;
async function asyncFind(arr, predicate) {
    for await (const e of arr) {
        if (await predicate(e)) {
            return e;
        }
    }
    return undefined;
}
exports.asyncFind = asyncFind;
function zip(...arrays) {
    const length = Math.min(...arrays.map((a) => a.length));
    const result = [];
    for (let i = 0; i < length; i += 1) {
        result.push(arrays.map((a) => a[i]));
    }
    return result;
}
exports.zip = zip;
function generateSubsets(initSet) {
    const subsets = [];
    function backtrack(start, currentSubset) {
        subsets.push([...currentSubset]);
        for (let i = start; i < initSet.length; i += 1) {
            currentSubset.push(initSet[i]);
            backtrack(i + 1, currentSubset);
            currentSubset.pop();
        }
    }
    backtrack(0, []);
    return subsets;
}
exports.generateSubsets = generateSubsets;
const toStringArray = (input) => {
    return Array.isArray(input) ? input : [input];
};
exports.toStringArray = toStringArray;
//# sourceMappingURL=index.js.map